import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { BUSINESS_TOOL } from 'constants/paths';
import * as ROUTES from 'constants/paths';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getSetBusinessPlanChapters } from 'store/useBusinessToolStore/selectors';

import { useAuthenticated } from 'hooks/useAuthenticated';
import { useExamplePreview } from 'hooks/useExamplePreview';

import { Switcher } from 'components/_basic/Switcher/Switcher';
import { useGetInitialValues } from 'components/BusinessToolForm/utils/form';

import { insertId } from 'helpers/path';

export const ViewExampleSwitch: React.FC = () => {
  const initialValues = useGetInitialValues();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthenticated();
  const { id: businessPlanId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const { isExamplePage, examplePdfUUID } = useExamplePreview();
  const docId = searchParams.get('docId');

  const setBusinessPlanChapters = useBusinessToolStore(getSetBusinessPlanChapters);

  const [isDocType, setIsDocType] = useState(!isExamplePage);

  useEffect(() => {
    if (!isDocType && !isExamplePage && examplePdfUUID) {
      navigate(`${insertId(BUSINESS_TOOL, examplePdfUUID)}${isAuthenticated ? `?docId=${businessPlanId}` : ''}`);
    } else if (docId && isDocType) {
      navigate(insertId(BUSINESS_TOOL, docId));
    } else if (isDocType && !isAuthenticated) {
      if (localStorage.getItem('unauthorizedBusinessToolStore')) {
        const unauthorizedBusinessToolStoreData = JSON.parse(localStorage.getItem('unauthorizedBusinessToolStore')!);
        setBusinessPlanChapters({ ...initialValues, ...unauthorizedBusinessToolStoreData });
      }
      navigate(ROUTES.HOME);
    }
  }, [isDocType]);

  return (
    <Switcher
      firstOption={t('myDoc')}
      secondOption={t('example')}
      isSwitcherOn={!isDocType}
      setSwitcherOn={setIsDocType}
    />
  );
};
